import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AUTH_FEATURE_KEY, AuthState } from './auth.reducer';
import { AuthorityDto, PermissionDto } from '@shared/dto';

export const selectAuthState = createFeatureSelector<Readonly<AuthState>>(AUTH_FEATURE_KEY);

export const selectRememberMe = createSelector(selectAuthState, (auth) => auth.rememberMe);
export const selectAccessToken = createSelector(selectAuthState, (auth) => auth.access);
export const selectRefreshToken = createSelector(selectAuthState, (auth) => auth.refresh);
export const selectDeviceToken = createSelector(selectAuthState, (auth) => auth.device);
// computed
export const isLoggedIn = createSelector(selectAccessToken, (token) => !!token);

// user profile selectors
export const selectUserProfile = createSelector(selectAuthState, (auth) => auth.profile);
export const selectUserClient = createSelector(selectAuthState, (auth) => auth.client);
export const selectUserAuthorities = createSelector(selectAuthState, (auth) => auth.authorities);
export const selectUserPermissions = createSelector(selectAuthState, (auth) => auth.permissions);
// computed
export const selectUserId = createSelector(selectAuthState, (auth) => auth.profile ? auth.profile.id : null);
export const selectUserFullName = createSelector(selectAuthState, (auth) => auth.profile ? `${auth.profile.firstName} ${auth.profile.lastName}` : null);
export const selectUserClientId = createSelector(selectAuthState, (auth) => auth.client ? auth.client.id : (auth.profile ? auth.profile.client.id : null));
export const selectUserAuthorityNames = createSelector(selectAuthState, (auth) => auth.authorities.map((authority: AuthorityDto) => authority.name));
export const selectUserPermissionNames = createSelector(selectAuthState, (auth) => auth.permissions.map((permission: PermissionDto) => permission.name));
